/* 🤖 this file was generated by svg-to-ts */
export const iconZealwallet: {
  name: 'zealwallet';
  data: string;
} = {
  name: 'zealwallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m8.49 24.56H7.37v-4.28c0-1.89 1.53-3.42 3.42-3.42h13.7zm0-12.84c0 1.89-1.53 3.42-3.42 3.42H7.37v-7.7h17.12z"/></svg>`,
};
